import {
  Component,
  OnInit,
} from '@angular/core';
import { RegistrationApiService } from '../../services/registration-api/RegistrationApiService';
import { RegistrationFormData } from '../registration-form/registration-form.component';
import { AccessService } from '../../../application/services/AccessService';
import { Router } from '@angular/router';

@Component({
  selector: 'app-registration',
  standalone: false,
  templateUrl: './registration.component.html',
  styleUrl: './registration.component.sass',
})
export class RegistrationComponent implements OnInit {
  public errorMessage: string | null = null;
  public registrationAvailable = false;

  public constructor(
    private registrationApi: RegistrationApiService,
    private accessService: AccessService,
    private router: Router,
  ) {}

  public ngOnInit(): void {
    void this.loadRegistrationStatus();
  }

  public async registration(data: RegistrationFormData): Promise<void> {
    this.errorMessage = null;
    if (!this.registrationAvailable) {
      await this.router.navigate([
        'sign-in',
      ]);
      return;
    }

    const response = await this.registrationApi.registration(data);
    if (response.status === 'failed') {
      this.errorMessage = response.errorMessage;
    } else {
      this.accessService.authorize(response.response.accessToken);
      await this.router.navigate([
        '',
      ]);
    }
  }

  private async loadRegistrationStatus(): Promise<void> {
    try {
      const response = await this.registrationApi.getRegistrationStatus();
      this.registrationAvailable = response.status === 'successful' && response.response.available;
    } catch {
      this.registrationAvailable = false;
    }

    if (!this.registrationAvailable) {
      await this.router.navigate([
        'sign-in',
      ]);
    }
  }

}
